<script setup>
import Preloader from '@/Components/Preloader.vue';
import Card from '@/Components/Card/Card.vue';
</script>

<template>
  <div
    v-for="(preloader, index) in [
      'a/aaaa',
      'txt',
      'mx',
      'ns',
      'cname',
      'caa',
      'soa',
      'srv'
    ]"
    :key="index"
  >
    <div class="text-lg font-bold uppercase" v-text="preloader" />
    <Card>
      <Preloader :rows="3" />
    </Card>
  </div>
</template>
